// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceTypeResource extends Resource {
    basePath: string = 'services/types/';

    objectPath: string = 'services/types/{ident}/';
}
